import React from "react";
import { DISABLE_MONTHLY_ULTIMATE } from "src/data/variables";

const TitlePlans = (): React.JSX.Element => {
  return (
    <div className="mt-20 flex w-full items-center justify-center">
      <div className="@container flex w-3/4 flex-col @[1366px]:items-start items-center @[1366px]:justify-start justify-center">
        <div className="flex @[1366px]:hidden ">
          <p className="flex w-fit bg-linear-to-r from-purple-100 to-blue-400 bg-clip-text font-bold text-6xl text-transparent">
            Compare<span className="ml-2 flex text-white"> Plans </span>
          </p>
        </div>
        <div className="grid @[1366px]:grid-cols-4 grid-cols-3 gap-40">
          <div className="@[1366px]:flex hidden ">
            <p className="flex w-fit bg-linear-to-r from-purple-100 to-blue-400 bg-clip-text font-bold text-6xl text-transparent">
              Compare<span className="ml-2 flex text-white"> Plans </span>
            </p>
          </div>
          <div className="mt-10 flex flex-col items-center text-center">
            <span className="flex font-bold text-[26px]">Free</span>
            <span className="flex font-extralight text-[16px] text-white-100 opacity-75">
              Its free forever
            </span>
          </div>
          <div className="mt-10 flex flex-col items-center text-center">
            <span className="flex font-bold text-[26px] text-blue-400">Premium</span>
            <span className="flex font-extralight text-[16px] text-white-100 opacity-75">
              Starting @ $95.88 Yearly
            </span>
          </div>
          <div className="mt-10 flex flex-col items-center text-center">
            <span className="flex font-bold text-[26px] text-purple-100">Ultimate</span>
            <span className="flex font-extralight text-[16px] text-white-100 opacity-75">
              {DISABLE_MONTHLY_ULTIMATE ? "Starting @ $179.88 Yearly" : "Starting @ $75/monthly"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TitlePlans;
